import { render, staticRenderFns } from "./registerEntry_tl10.vue?vue&type=template&id=dd51f5c0&scoped=true"
import script from "./registerEntry_tl10.vue?vue&type=script&lang=js"
export * from "./registerEntry_tl10.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/registerEntry_tl10.scss?vue&type=style&index=0&id=dd51f5c0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd51f5c0",
  null
  
)

export default component.exports